import paths from '@src/paths';

const navItems = [
  {
    key: 'dashboards',
    title: 'Lead Gurus Dashboards',
    items: [
      { key: 'dailyPulse', title: 'Daily Pulse', href: paths.dashboard.dailyPulse, icon: 'calendar-check' },
      { key: 'performanceTrends', title: 'Performance Trends', href: paths.dashboard.performanceTrends, icon: 'pulse' },
      { key: 'companyPerformance', title: 'Company Performance', href: paths.dashboard.companyPerformance, icon: 'table' },
      { key: 'clientPerformanceAggregator', title: 'Client Performance Aggregator', href: paths.dashboard.clientPerformanceAggregator, icon: 'table' },
    ],
  },
  {
    key: 'clients',
    title: 'Clients',
    items: [
      {
        key: 'clientList',
        title: 'Clients',
        href: paths.clients,
        icon: 'users',
      },
      {
        key: 'clientZips',
        title: 'Client Zips',
        href: paths.clientZips,
        icon: 'map-pin',
      },
      {
        key: 'clientLanes',
        title: 'Client Lanes',
        href: paths.clientLanes,
        icon: 'table',
      },
      {
        key: 'clientBudgets',
        title: 'Client Budgets',
        href: paths.clientBudgets,
        icon: 'trend-up',
      },
      {
        key: 'clientOffers',
        title: 'Client Offers',
        href: paths.clientOffers,
        icon: 'receipt',
      },
      {
        key: 'onboardingFlow',
        title: 'Onboarding',
        href: paths.onboarding.list,
        icon: 'list-checks',
      },
      {
        key: 'clientInvites',
        title: 'Invite Members',
        href: paths.clientInvites,
        icon: 'envelope-simple',
      },
      {
        key: 'backendData',
        title: 'Backend Data',
        icon: 'table',
        items: [
          {
            key: 'backendDataList',
            title: 'List Records',
            href: paths.backendData.list,
          },
          {
            key: 'backendDatasummary',
            title: 'Summary',
            href: paths.backendData.summary,
          },
        ],
      },
      {
        key: 'leads',
        title: 'Leads',
        icon: 'users',
        items: [
          {
            key: 'leadsList',
            title: 'List Leads',
            href: paths.leads.list,
          },
        ],
      },
    ],
  },
  {
    key: 'management',
    title: 'Management',
    items: [
      {
        key: 'invoices',
        title: 'Invoices',
        icon: 'receipt',
        items: [
          {
            key: 'invoices:list',
            title: 'List invoices',
            href: paths.dashboard.invoices.list,
          },
          {
            key: 'invoices:create',
            title: 'Create invoice',
            href: paths.dashboard.invoices.create,
          },
          {
            key: 'invoices:settings',
            title: 'Invoice settings',
            href: paths.dashboard.invoices.settings,
          },
          {
            key: 'invoices:details',
            title: 'Invoice details',
            href: paths.dashboard.invoices.details(':invoiceId'),
            disabled: true,
          },
        ],
      },
      {
        key: 'clientInbox',
        title: 'Client Inbox',
        href: paths.clientInbox,
        icon: 'envelope-simple',
      },
      {
        key: 'knowledgeBase',
        title: 'Knowledge Base',
        href: paths.knowledgeBase,
        icon: 'book',
      },
      {
        key: 'emailMappings',
        title: 'Backend Mappings',
        href: paths.emailMappings,
        icon: 'link-simple',
      },
      {
        key: 'tasks',
        title: 'Tasks',
        href: paths.dashboard.tasks,
        icon: 'kanban',
      },
      {
        key: 'taskLogger',
        title: 'Task Logger',
        href: paths.taskLogger,
        icon: 'list-checks',
      },
      {
        key: 'dataBackfill',
        title: 'Data Backfill',
        href: paths.dashboard.dataBackfill,
        icon: 'calendar-check',
      },
      {
        key: 'adNameBuilder',
        title: 'Ad Name Builder',
        href: paths.adBuilder,
        icon: 'file',
      },
      {
        key: 'campaignBuilder',
        title: 'Campaign Builder',
        href: paths.facebook.campaignBuilder,
        icon: 'share-network',
      },
    ],
  },
  {
    key: 'flows',
    title: 'Flows',
    items: [
      {
        key: 'flowsHub',
        title: 'Flow Hub',
        href: paths.flows.hub,
        icon: 'list-checks',
      },
      {
        key: 'zipCodeUpdatesFlow',
        title: 'ZIP Code Updates',
        href: paths.flows.zipCodeUpdates,
        icon: 'map-pin',
      },
    ],
  },
];

function filterNavItemsForUser(items = [], user, options = {}) {
  if (!user) {
    return [];
  }

  if (user.is_staff || user.is_superuser) {
    return items;
  }

  const normalizeSlug = (value = '') =>
    value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  const getMembershipDashboardSlug = (membership = {}) => {
    const clientSlug = membership?.client_slug || membership?.client_id;
    if (clientSlug) {
      return clientSlug;
    }
    const parentName = membership?.parent_company_name;
    if (parentName) {
      return normalizeSlug(parentName);
    }
    return membership?.parent_company_id || null;
  };

  const memberships = Array.isArray(user.client_memberships) ? user.client_memberships : [];
  const parentScopeClients = Array.isArray(options.parentScopeClients)
    ? options.parentScopeClients
    : [];
  if (memberships.length) {
    const defaultMembership = memberships[0];
    const clientSlug = getMembershipDashboardSlug(defaultMembership);
    const clientStatus = String(defaultMembership?.client_status || '').toLowerCase();
    const onboardingAllowed = ['new_business', 'onboarding'].includes(clientStatus);
    const isParentScopeMembership = !defaultMembership?.client_id && Boolean(
      defaultMembership?.parent_company_id || defaultMembership?.parent_company_name
    );

    // If we can't resolve a client identifier, fail closed and hide the menu.
    if (!clientSlug) {
      return [];
    }

    if (onboardingAllowed) {
      return [
        {
          key: 'client-onboarding-group',
          title: 'Onboarding',
          items: [
            {
              key: 'client-onboarding',
              title: 'Onboarding',
              href: paths.onboarding.forClient(clientSlug),
              icon: 'list-checks',
            },
          ],
        },
      ];
    }

    if (isParentScopeMembership) {
      const normalizedDefaultSlug = normalizeSlug(
        defaultMembership?.parent_company_name || ''
      );
      const sortedClients = [...parentScopeClients]
        .map((client = {}) => ({
          id: client.id,
          name: client.name || `Client ${client.id}`,
          slug: client.slug || normalizeSlug(client.name || String(client.id || '')),
        }))
        .filter((client) => Boolean(client.slug))
        .filter((client) => normalizeSlug(client.slug) !== normalizedDefaultSlug)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
      const clientLinks = sortedClients.map((client) => ({
        key: `parent-client-dashboard-${client.id}`,
        title: client.name,
        href: paths.clientDashboard(client.slug),
      }));
      const parentClientNavItems = [...clientLinks];

      return [
        {
          key: 'client-dashboard-group',
          title: 'Dashboard',
          items: [
            {
              key: 'client-dashboard',
              title: 'Performance Dashboard',
              href: paths.clientDashboard(clientSlug),
              icon: 'chart-pie',
            },
            ...(parentClientNavItems.length
              ? [
                  {
                    key: 'parent-client-dashboards',
                    title: 'Clients',
                    icon: 'users',
                    items: parentClientNavItems,
                  },
                ]
              : []),
          ],
        },
      ];
    }

    return [
      {
        key: 'client-dashboard-group',
        title: 'Dashboard',
        items: [
          {
            key: 'client-dashboard',
            title: 'Performance Dashboard',
            href: paths.clientDashboard(clientSlug),
            icon: 'chart-pie',
          },
        ],
      },
    ];
  }

  const allowedKeys = new Set([
    'clientList',
    'clientZips',
    'clientBudgets',
    'onboardingFlow',
    'clientInbox',
    'knowledgeBase',
    'flowsHub',
    'zipCodeUpdatesFlow',
  ]);

  const filterItems = (list = []) =>
    list
      .map((item) => {
        const nextItems = item.items ? filterItems(item.items) : [];
        const keepSelf = allowedKeys.has(item.key);
        if (nextItems.length) {
          return { ...item, items: nextItems };
        }
        return keepSelf ? { ...item, items: undefined } : null;
      })
      .filter(Boolean);

  return items
    .map((group) => {
      const nextItems = filterItems(group.items || []);
      return { ...group, items: nextItems };
    })
    .filter((group) => group.items && group.items.length);
}

export default { navItems };
export { filterNavItemsForUser };
